var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 31,
    viewBox: "0 0 43 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7637 24.5103C13.9338 23.3136 15.0968 22.1243 16.2561 20.935C17.773 22.4078 19.8497 22.3011 21.1426 21.4394C21.8902 20.9387 22.4248 20.2648 22.7318 19.4032C23.0387 18.5453 23.046 17.68 22.7751 16.7962C24.6856 17.3081 26.2025 16.7373 27.3835 15.1172C27.7916 16.2623 27.9433 17.4369 27.8603 18.6336C27.6869 21.1228 26.7154 23.24 24.8698 24.897C21.2546 28.1446 15.9058 27.758 12.7637 24.5103Z",
    fill: "#003B90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2905 6.56643C29.1312 7.75208 27.9827 8.93037 26.8378 10.1013C25.2812 8.76099 23.6126 8.51428 21.8465 9.62629C20.6836 10.3554 19.6579 12.0823 20.2719 14.2106C18.3541 13.6914 16.8264 14.2732 15.667 15.897C14.5691 12.8997 15.1759 8.24549 18.9789 5.53911C22.6122 2.95056 27.4518 3.59862 30.2905 6.56275V6.56643Z",
    fill: "#003B90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6626 12.95C21.659 11.606 22.7136 10.5271 24.0318 10.5234C25.3573 10.5234 26.4227 11.6023 26.4263 12.95C26.4263 14.2829 25.3609 15.3765 24.0535 15.3802C22.7316 15.3802 21.6698 14.3013 21.6662 12.95H21.6626Z",
    fill: "#003B90"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3879 18.0784C21.3987 19.393 20.3441 20.4792 19.0475 20.4939C17.7221 20.5087 16.635 19.4371 16.6313 18.0711C16.6313 16.6203 17.7871 15.6593 18.9789 15.6409C20.2755 15.6224 21.4167 16.7124 21.3842 18.0784H21.3879Z",
    fill: "#003B90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2bc0ba5e834db1e31988dd0f1f71afb4.svg";
export { ForwardRef as ReactComponent };